import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { AppConstants } from 'src/app/core/constants/constants'; 

@Injectable({
    providedIn: 'root'
})
export class AIChatService {

    constructor(private _httpClient: HttpClient) { }

    startConversion(): Observable<any> {
        const url = `${AppConstants.API.GPT_DATA_API}/start`;
        return this._httpClient.post<any>(url, {})
    }

    askDebenAssistant(usersConversationId: string, body: any) {
        const url = `${AppConstants.API.GPT_DATA_API}/${usersConversationId}/ask`;
        return this._httpClient.post<any>(url, body)
    }

}
